import { useQuery } from "react-query"
import { get_timesheets } from "../../services/timesheet";


const useTimesheets = (page, filters, sort_by) => {
    return useQuery(['get_timesheets', page, filters, sort_by],() => get_timesheets(page, filters, sort_by))
} 

export default useTimesheets;
 